/* eslint-disable react/jsx-no-bind */

import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { BASE_FONTS } from '../../brands/default/config';
import { getIcon } from '../../helpers/headerIcon';
import ThemeContext from '../../providers/ThemeProvider';
import Icon from '../Icon';

const HeaderIcon = ({ ariaHasPopup, ariaExpanded, icon, href }) => {
  const theme = useContext(ThemeContext);
  let faIcon = faMapMarkerAlt;
  let tooltip = '';
  let ariaLabel = '';
  let dataQa = '';

  ({ ariaLabel, dataQa, faIcon, tooltip } = getIcon(icon, false, null));

  return (
    <div className={'header-icon'}>
      <a
        aria-expanded={ariaExpanded}
        aria-haspopup={ariaHasPopup}
        aria-label={ariaLabel}
        className={`header-icon__link ${icon.toLowerCase()}__link`}
        data-qa={dataQa}
        href={href}
        role="button"
        tabIndex="0"
      >
        <Icon faIcon={faIcon} />
        <span className="sr-only">{ariaLabel}</span>
      </a>
      <div className="header-icon__tooltip">{tooltip}</div>
      <style jsx>{`
        .header-icon {
          font-family: ${BASE_FONTS};
          display: inline-block;
          margin-left: 10px;
          position: relative;
          text-align: center;
        }
        .header-icon--is-first {
          margin-left: 0;
        }
        @media (min-width: 768px) {
          @media (pointer: fine) {
            a:hover + .header-icon__tooltip {
              display: block;
            }
          }
        }
        @media (max-width: 767.98px) {
          .header-icon--hidden-mobile {
            display: none;
          }
        }

        .header-icon__tooltip {
          color: ${theme.colors.primary};
          display: none;
          font-size: 12px;
          top: 100%;
          left: 50%;
          position: absolute;
          transform: translateX(-50%);
        }
        .header-icon__link {
          display: block;
          border: none;
          line-height: 20px;
          height: 20px;
          width: 20px;
        }
        @media (min-width: 768px) {
          .header-icon__link {
            border: solid;
            border-radius: 32px;
            border-color: ${theme.colors.primary};
            line-height: 27px;
            height: 32px;
            width: 32px;
          }
        }
        .wishlist__link {
          padding: 1px 0 0 1px;
        }
      `}</style>
    </div>
  );
};

export default HeaderIcon;

HeaderIcon.propTypes = {
  ariaExpanded: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  ariaHasPopup: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  href: PropTypes.string,
  icon: PropTypes.string.isRequired,
};

HeaderIcon.defaultProps = {
  ariaExpanded: null,
  ariaHasPopup: null,
};
